import CheckOutlined from '@mui/icons-material/CheckOutlined';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { type MouseEvent, type ReactNode, useState } from 'react';
import { ControlButton } from './ControlButton';
import { FILTER_MENU_SLOT_PROPS, filterMenuItemSx } from './menuStyles';
import type { ScopeOption } from './types';

interface SingleSelectControlProps {
  label: string;
  options: ScopeOption[];
  value: string;
  onChange: (value: string) => void;
  onRemove?: () => void;
}

export function SingleSelectControl({
  label,
  options,
  value,
  onChange,
  onRemove,
}: SingleSelectControlProps): ReactNode {
  const [anchor, setAnchor] = useState<HTMLButtonElement | null>(null);
  const current = options.find((option) => option.id === value);

  return (
    <>
      <ControlButton
        label={label}
        value={current?.label ?? value}
        open={anchor !== null}
        onClick={(event: MouseEvent<HTMLButtonElement>) => setAnchor(event.currentTarget)}
        labelFirst
        {...(onRemove ? { onRemove } : {})}
      />
      <Menu
        anchorEl={anchor}
        open={anchor !== null}
        onClose={() => setAnchor(null)}
        slotProps={FILTER_MENU_SLOT_PROPS}
      >
        {options.map((option) => (
          <MenuItem
            key={option.id}
            selected={option.id === value}
            onClick={() => {
              onChange(option.id);
              setAnchor(null);
            }}
            sx={filterMenuItemSx}
          >
            <ListItemText primary={option.label} sx={{ m: 0 }} />
            {option.id === value ? <CheckOutlined fontSize="small" /> : null}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
